<template>
	<div class="character"
		@click="setCharacter( npc )"
		:class="{ 'current' : getCurrentCharacterId === npc.id}">

		<div class="img" :class="{ 'unplayable' : !npc.isPlayable }">
			<img :src="require( `@/assets/sprites/npc/${npc.sprite}.png` )" :alt="npc.name">
			<h3 class="name font-serif" :class="{ 'name-small' : npc.name.length >= 10 }">{{ npc.name }}</h3>
		</div>

		<div class="details">
			<div class="specs font-sans">
				<div class="spec-row">
					<div class="spec-key">HP:</div>
					<div class="spec-value">{{ npc.hp }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">Speed:</div>
					<div class="spec-value">{{ npc.run_speed }}</div>
				</div>

				<div class="spec-row">
					<div class="spec-key">{{firstWeaponString( npc )}}:</div>
					<div class="spec-value" :class="{ 'melee-only' : !npc.abilities.gun_weapons }">
						<div>
							{{ getWeaponNameByIndex( npc.wpn1_index ) }}{{ weaponAffix( npc ) }}
						</div>
						<div v-if="hasSecondWeapon( npc ) && npc.wpn1_index !== hasSecondWeapon( npc )">
							{{ getWeaponNameByIndex( npc.wpn2_index ) }}
						</div>
					</div>
				</div>
			</div>

			<div class="specs more-specs font-sans" v-show="showExtraData">
				<div class="spec-row">
					<div class="spec-key">id:</div>
					<div class="spec-value">{{ npc.id }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">sprite:</div>
					<div class="spec-value">{{ npc.sprite }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">wpn1_index:</div>
					<div class="spec-value">{{ npc.wpn1_index }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">wpn2_index:</div>
					<div class="spec-value">{{ npc.wpn2_index }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">blood_type:</div>
					<div class="spec-value">{{ npc.blood_type }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">isBoss:</div>
					<div class="spec-value">{{ npc.isBoss }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">isPlayable:</div>
					<div class="spec-value">{{ npc.isPlayable }}</div>
				</div>
				<div class="spec-row">
					<div class="spec-key">canRagdoll:</div>
					<div class="spec-value">{{ npc.canRagdoll }}</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import bloodType from '@/modules/data/bloodType'
	import weapons from '@/modules/data/weapons'

	export default {
		name: 'CharacterCard',
		props: {
			npc: {
				type: Object,
				required: true
			},
			group: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				// npc,
				// weapons,
				a11ytext: false
			}
		},
		computed: {
			getCurrentCharacterId()
			{
				return this.$store.getters.getCharacterId;
			},
			showExtraData()
			{
				return this.$store.getters.getShowExtraData;
			}
		},
		methods: {
			firstWeaponString( npc )
			{
				return ( this.hasSecondWeapon( npc ) ) ? 'Weapons' : 'Weapon';
			},
			weaponAffix( npc )
			{
				if ( npc.wpn1_index === this.hasSecondWeapon( npc ) )
				{
					return ' x2';
				}
				else if ( this.hasSecondWeapon( npc ) )
				{
					return ','
				}

				return '';
			},
			hasSecondWeapon( npc )
			{
				// Returns null if second weapon is punch (4) or "player choice" (-1)
				return ( npc.wpn2_index !== 4 && npc.wpn2_index !== -1 ) ? npc.wpn2_index : null;
			},
			getWeaponNameByIndex( wpnIndex )
			{
				let wpnString = '';

				switch( wpnIndex )
				{
					case -1:
						wpnString = 'Player Choice';
						break;

					case 4: // Punch
						wpnString = 'Melee';
						break;

					default:
						wpnString = weapons.filter( w => w.index === wpnIndex )[0].name;
				}

				return wpnString;
			},
			getBloodTypeNameById( bloodId )
			{
				return bloodType[bloodId]?.name || '?';
			},
			setCharacter( npc )
			{
				// Set character
				this.$store.commit( 'setCharacterId', npc.id );

				// Set weapons
				this.$store.commit( 'setPrimaryWeapon', npc.wpn1_index );
				this.$store.commit( 'setSecondaryWeapon', npc.wpn2_index );
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/scss/_variables.scss';

	// Single NPC
	// ====================================

	.character {
		// background-color: #333;
		// background-color: #222222;
		align-items: center;
		cursor: pointer;
		display: flex;
		padding: 0;
		position: relative;

		&:hover:not(.current) {
			.img {
				animation-duration: 1.5s;
				animation-iteration-count: infinite;
				animation-name: polaroid-glow;
				animation-timing-function: ease-out;
				// border-color: $color-or;
			}
		}

		&.current {
			cursor: default;
		}
	}

	.name {
		color: #333;
		font-size: 1.5rem;
		left: 5px;
		margin: 0;
		position: absolute;
		text-align: center;
		top: 115px;
		width: 107px;

		&.name-small {
			font-size: 1.1rem;
			padding-top: 5px;
		}

		.unplayable & {
			color: #885753;
		}
	}

	// $glow-color: $color-or; // orange
	// $glow-color: $color-g;
	$glow-color: #fff;

	@keyframes polaroid-glow {
		0% {
			box-shadow: 1px 1px 10px $glow-color;
		}

		50% {
			box-shadow: 1px 1px 20px $glow-color;
		}

		100% {
			box-shadow: 1px 1px 10px $glow-color;
		}
	}

	// Image (Polaroid)
	// ====================================

	$default-image-size: 21px;

	.img {
		background-color: #f5f5f5;
		height: 150px;
		margin-right: 20px;
		margin: 0;
		padding: 5px;
		position: relative;

		&.unplayable {
			background-color: darken($color-r, 50);
		}

		img {
			background-color: #616161;
			height: $default-image-size * 5;
			image-rendering: pixelated;
			width: $default-image-size * 5;
		}
	}

	// Character Specs
	// ====================================

	.details {
		background-color: #222222;
		padding: 10px;
		width: 100%;
		padding: 10px 10px 15px 20px;
		transition: 0.2s;

		.current & {
			background-color: darken($color-g, 40);
		}
	}

	.specs {
		font-size: 1.2rem;
		line-height: 1.1;
		padding: 0px;
	}

	.spec-row {
		display: flex;
		margin-bottom: 5px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.spec-key {
		flex: 0 0 75px;
	}

	.spec-value {
		flex-grow: 1;
	}

	.melee-only {
		color: $color-r;
	}

	.more-specs {
		font-size: 1.1rem;
		line-height: 1;
		margin-top: 10px;

		.spec-key {
			flex: 0 0 90px;
		}

		.spec-row:nth-of-type(odd) {
			background-color: rgba(255, 255, 255, .1);
		}
	}

</style>
